import WSPromisify from 'wspromisify';
const WS_HOST = process.env.WS_HOST;
const TOKEN_NAME = process.env.WS_AUTH_TOKEN_NAME;

export namespace WSP {
  const connectUrl = `${WS_HOST}?idToken=${TOKEN_NAME}`;

  const wsConfig: wsc.UserConfig = {
    // * Timeout after sending a message before it drops with error
    timeout: 30e3, // 1400ms by default.
    // * Will count milliseconds for responses and put them to log function above.
    timer: true, // false by default.
    // * If url starts with /,
    // * it results in ws(s if in https)://currentHost:currentPort/thisUrl
    url: connectUrl,
    // * Reconnect timeout in seconds or null
    reconnect: undefined,
    // * Pings to avoid interruptions. null to disable.
    ping: {
      interval: 180, // seconds.
      content: {},
    },
    // * Lazy connect: connects only if something sent (then sends all of them!)
    // lazy: false,
    // * Existing socket if you already have one to augment with this force.
    // socket: null,
    // * You can set your own middleware here.
    // adapter: ((host, protocols) => new WebSocket(host, protocols)),
    // * To log data trips. Events: open, close, send, reconnect, error.
    // * If timer isn't enabled, the signature is log(event, message)
    // log(event, time, message = '') {
    //   if (time !== null) {
    //     console.log('wsp:', { event }, `in ${time}ms`, message);
    //   } else {
    //     console.log('wsp:', { event }, message);
    //   }
    // },
    encode: (messageId, messageData /*, config*/) =>
      JSON.stringify({
        id: messageId,
        ...messageData,
      }),
    // * You can replace original deserialisation to your own or even
    //     making the message object from binary data.
    //     id_key and data_key could be taken from the config argument.
    // decode: (raw_message) => { message_id, message_data },
    // * WebSocket constructor's protocol field.
    // protocols: [],
    // * Unique id's and data keys to negotiate with back-end.
    // server: {
    //   id_key: 'id',
    //   data_key: 'data'
    // },
  };

  export function create(socket: WebSocket): WSPromisify {
    return new WSPromisify({
      ...wsConfig,
      socket,
    });
  }
}
